import { Image } from 'lucide-react';

interface Props {
  url: string | undefined;
}

export function TableThumbnail({ url }: Props) {
  if (!url) {
    return (
      <div className="bg-muted flex h-14 w-20 items-center justify-center rounded">
        <Image className="text-muted-foreground size-4.5" />
      </div>
    );
  }

  return (
    <img
      alt="Creative Thumbnail"
      className="h-14 w-20 rounded object-cover"
      src={url}
    />
  );
}
